var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scope"},[_c('div',{staticClass:"paymentSystem"},[_c('div',{staticClass:"mb-2 topic text-center"},[_c('b',[_vm._v(_vm._s(_vm.topic[this.page-1]))]),_c('br')]),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail[this.page-1])}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }